'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Image from 'next/image';
import { Loader2 } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { RiGithubFill, RiGoogleFill } from 'react-icons/ri';
import { toast } from 'sonner';
import { signIn } from '@/core/auth/client';
import { useRouter } from '@/core/i18n/navigation';
import { Button } from '@/shared/components/ui/button';
import { useAppContext } from '@/shared/contexts/app';
import { cn } from '@/shared/lib/utils';
import { Button as ButtonType } from '@/shared/types/blocks/common';
import { PricingItem } from '@/shared/types/blocks/pricing';
export function PaymentProviders(t0) {
  const $ = _c(26);
  const {
    configs,
    loading,
    pricingItem,
    onCheckout,
    className
  } = t0;
  useTranslations("common.payment");
  useRouter();
  useAppContext();
  const [paymentProvider, setPaymentProvider] = useState(null);
  let t1;
  if ($[0] !== onCheckout || $[1] !== pricingItem) {
    t1 = async t2 => {
      const {
        provider
      } = t2;
      if (!provider) {
        toast.error("please select payment method");
        return;
      }
      if (!pricingItem) {
        toast.error("please select a pricing item");
        return;
      }
      onCheckout(pricingItem, provider);
    };
    $[0] = onCheckout;
    $[1] = pricingItem;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handlePayment = t1;
  const allowedProviders = pricingItem?.payment_providers;
  let t2;
  if ($[3] !== allowedProviders) {
    t2 = providerName => {
      if (!allowedProviders || allowedProviders.length === 0) {
        return true;
      }
      return allowedProviders.includes(providerName);
    };
    $[3] = allowedProviders;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const isProviderAllowed = t2;
  let providers;
  if ($[5] !== configs.creem_enabled || $[6] !== configs.paypal_enabled || $[7] !== configs.stripe_enabled || $[8] !== handlePayment || $[9] !== isProviderAllowed) {
    providers = [];
    if (configs.stripe_enabled === "true" && isProviderAllowed("stripe")) {
      let t3;
      if ($[11] !== handlePayment) {
        t3 = {
          name: "stripe",
          title: "Stripe",
          icon_url: "/imgs/icons/stripe.png",
          onClick: () => handlePayment({
            provider: "stripe"
          })
        };
        $[11] = handlePayment;
        $[12] = t3;
      } else {
        t3 = $[12];
      }
      providers.push(t3);
    }
    if (configs.creem_enabled === "true" && isProviderAllowed("creem")) {
      let t3;
      if ($[13] !== handlePayment) {
        t3 = {
          name: "creem",
          title: "Creem",
          icon_url: "/imgs/icons/creem.png",
          onClick: () => handlePayment({
            provider: "creem"
          })
        };
        $[13] = handlePayment;
        $[14] = t3;
      } else {
        t3 = $[14];
      }
      providers.push(t3);
    }
    if (configs.paypal_enabled === "true" && isProviderAllowed("paypal")) {
      let t3;
      if ($[15] !== handlePayment) {
        t3 = {
          name: "paypal",
          title: "Paypal",
          icon_url: "/imgs/icons/paypal.svg",
          onClick: () => handlePayment({
            provider: "paypal"
          })
        };
        $[15] = handlePayment;
        $[16] = t3;
      } else {
        t3 = $[16];
      }
      providers.push(t3);
    }
    $[5] = configs.creem_enabled;
    $[6] = configs.paypal_enabled;
    $[7] = configs.stripe_enabled;
    $[8] = handlePayment;
    $[9] = isProviderAllowed;
    $[10] = providers;
  } else {
    providers = $[10];
  }
  let t3;
  if ($[17] !== className) {
    t3 = cn("flex w-full items-center gap-2", "flex-col justify-between", className);
    $[17] = className;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] !== loading || $[20] !== paymentProvider || $[21] !== providers) {
    t4 = providers.map(provider_0 => <Button key={provider_0.name} variant="outline" className={cn("w-full gap-2")} disabled={loading} onClick={() => {
      if (!provider_0.onClick || !provider_0.name) {
        toast.error("invalid payment method");
        return;
      }
      setPaymentProvider(provider_0.name);
      provider_0.onClick();
    }}>{provider_0.icon_url && <Image src={provider_0.icon_url} alt={provider_0.title || provider_0.name || ""} width={24} height={24} className="rounded-full" />}<h3>{provider_0.title}</h3>{paymentProvider === provider_0.name && loading && <Loader2 className="size-4 animate-spin" />}</Button>);
    $[19] = loading;
    $[20] = paymentProvider;
    $[21] = providers;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== t3 || $[24] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  return t5;
}